import Image from 'next/image';
import { ButtonHTMLAttributes } from 'react';

interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
  label: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  src?: string;
  variant?: 'primary' | 'secondary';
}

const CustomButton = ({
  onClick,
  label,
  className = '',
  type = 'button', // Default type to prevent form submission
  src,
  variant = 'primary', // Default to primary
  ...props // Allow passing other button props
}: CustomButtonProps) => {
  return (
    <button
      type={type}
      className={`btn 
        ${variant === 'primary' ? 'btn-primary' : 'btn-secondary'}
        px-[0.8125rem] py-[0.78125rem] leading-none flex items-center gap-2 
        ${className}`}
      onClick={onClick}
      {...props}
    >
      {src && (
        <Image src={src} alt={label} className='me-5' width={20} height={20} />
      )}
      {label}
    </button>
  );
};

export default CustomButton;
